// @flow
import { APICore } from './apiCore';

const api = new APICore();

// account
function login(params: any): any {
    const baseUrl = '/user/login';
    return api.create(`${baseUrl}`, params);
    // console.log('🚀 ~ login ~ params:', params);
}

function logout(): any {
    const baseUrl = '/api/admin/logout';
    var params = {
        username: 'Admin',
        password: 'admin',
    };
    return api.create(`${baseUrl}`, params);
}

function signup(params: any): any {
    const baseUrl = '/user/users';
    return api.create(`${baseUrl}`, params);
}

function forgotPassword(params: any): any {
    const baseUrl = '/forget-password/';
    return api.create(`${baseUrl}`, params);
}

function forgotPasswordConfirm(params: any): any {
    const baseUrl = '/password/reset/confirm/';
    return api.create(`${baseUrl}`, params);
}

export { login, logout, signup, forgotPassword, forgotPasswordConfirm };
